/* eslint-disable react/prop-types */
import React from 'react';
import classnames from 'classnames';
import type { UAPPlacementComponentProps } from '../../@types';

import { withUAPLThemedStyles } from '../../with-themed-styles';
import {
  AdPlacementBoostDiscoverCard1x1,
  AdPlacementBoostProngFeed191x100,
  AdPlacementBoostCoachmark175x100,
  AdPlacementBoostStartMenu,
  AdPlacementBoostActionCenter,
  AdPlacementBoostBanner,
  AdPlacementBoostContentHub,
  AdPlacementBoostMicrosoftPlus,
} from '../index';
import { UnstyledWindowsSpotlight191x100 } from '../boost-ad-placements/boost-windows-spotlight-placement';
import { UnstyledMiniSpotlight } from '../boost-ad-placements/boost-mini-spotlight-placement';
import { UnstyledSpotlightPortrait } from '../boost-ad-placements/boost-spotlight-portrait-placement';
import {
  getResponsiveBoostWindowsSpotlight191x100Styles,
  getResponsiveBoostSpotlightPortraitStyles,
  getResponsiveBoostMiniSpotlightStyles,
} from '../../styles/ad-placement-components/boost-ad-placements-styles';

export const ResponsiveAdPlacementBoostDiscoverCard1x1 = ({
  customClassName,
  ...rest
}: UAPPlacementComponentProps) => (
  <div className={classnames(customClassName, 'responsive-boost-ad-placement-container')}>
    <AdPlacementBoostDiscoverCard1x1 {...rest} />
  </div>
);

export const ResponsiveAdPlacementBoostProngFeed191x100 = ({
  customClassName,
  ...rest
}: UAPPlacementComponentProps) => (
  <div className={classnames(customClassName, 'responsive-boost-ad-placement-container')}>
    <AdPlacementBoostProngFeed191x100 {...rest} />
  </div>
);

export const ResponsiveAdPlacementBoostCoachmark175x100 = ({
  customClassName,
  ...rest
}: UAPPlacementComponentProps) => (
  <div className={classnames(customClassName, 'responsive-boost-ad-placement-container')}>
    <AdPlacementBoostCoachmark175x100 {...rest} />
  </div>
);

export const ResponsiveAdPlacementBoostStartMenu = ({
  customClassName,
  ...rest
}: UAPPlacementComponentProps) => (
  <div className={classnames(customClassName, 'responsive-boost-ad-placement-container', 'responsive-boost-start-menu')}>
    <AdPlacementBoostStartMenu {...{ ...rest, isEnabled: true }} />
  </div>
);

export const ResponsiveAdPlacementBoostActionCenter = ({
  customClassName,
  ...rest
}: UAPPlacementComponentProps) => (
  <div className={classnames(customClassName, 'responsive-boost-ad-placement-container', 'responsive-boost-action-center')}>
    <AdPlacementBoostActionCenter {...{ ...rest, isEnabled: true }} />
  </div>
);

export const ResponsiveAdPlacementBoostBanner = ({
  customClassName,
  ...rest
}: UAPPlacementComponentProps) => (
  <div className={classnames(customClassName, 'responsive-boost-ad-placement-container', 'responsive-boost-banner')}>
    <AdPlacementBoostBanner {...{ ...rest, isEnabled: true }} />
  </div>
);

const BoostWindowsSpotlight191x100 = withUAPLThemedStyles(
  UnstyledWindowsSpotlight191x100,
  getResponsiveBoostWindowsSpotlight191x100Styles,
  { componentName: 'ResponsiveAdPlacementBoostWindowsSpotlight191x100' }
);

export const ResponsiveAdPlacementBoostWindowsSpotlight191x100 = ({
  customClassName,
  ...rest
}: UAPPlacementComponentProps) => (
  <div className={classnames(customClassName, 'responsive-boost-ad-placement-container', 'responsive-boost-windows-spotlight')}>
    <BoostWindowsSpotlight191x100 {...rest} />
  </div>
);

const BoostMiniSpotlight = withUAPLThemedStyles(
  UnstyledMiniSpotlight,
  getResponsiveBoostMiniSpotlightStyles,
  { componentName: 'ResponsiveAdPlacementBoostMiniSpotlight' }
);

export const ResponsiveAdPlacementBoostMiniSpotlight = ({
  customClassName,
  ...rest
}: UAPPlacementComponentProps) => (
  <div className={classnames(customClassName, 'responsive-boost-ad-placement-container', 'responsive-boost-mini-spotlight')}>
    <BoostMiniSpotlight {...rest} />
  </div>
);

const BoostSpotlightPortrait = withUAPLThemedStyles(
  UnstyledSpotlightPortrait,
  getResponsiveBoostSpotlightPortraitStyles,
  { componentName: 'ResponsiveAdPlacementBoostSpotlightPortrait' }
);

export const ResponsiveAdPlacementBoostSpotlightPortrait = ({
  customClassName,
  ...rest
}: UAPPlacementComponentProps) => (
  <div className={classnames(customClassName, 'responsive-boost-ad-placement-container', 'responsive-boost-spotlight-portrait')}>
    <BoostSpotlightPortrait {...rest} />
  </div>
);

export const ResponsiveAdPlacementBoostContentHub = ({
  customClassName,
  ...rest
}: UAPPlacementComponentProps) => (
  <div className={classnames(customClassName, 'responsive-boost-ad-placement-container', 'responsive-boost-content-hub')}>
    <AdPlacementBoostContentHub {...rest} />
  </div>
);

export const ResponsiveAdPlacementBoostMicrosoftPlus = ({
  customClassName,
  ...rest
}: UAPPlacementComponentProps) => (
  <div className={classnames(customClassName, 'responsive-boost-ad-placement-container', 'responsive-boost-microsoft-plus')}>
    <AdPlacementBoostMicrosoftPlus {...rest} />
  </div>
);
